// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__38TF6","textNameAvatar":"Avatar_textNameAvatar__21dt5"};